import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'productDesc' })
export class ProductDescriptionPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(product: any): SafeHtml | null {
    if (!product?.description) return null;

    const parts: string[] = [];

    if (product?.alcoholByVolume != null && !isNaN(product.alcoholByVolume)) {
      const abv = Number(product.alcoholByVolume).toFixed(1);
      parts.push(`${abv}% ABV`);
    }

    if (product?.alcoholUnit != null && !isNaN(product.alcoholUnit)) {
      const units = Number(product.alcoholUnit).toFixed(1);
      const unitText = `${units} units`;
      if (product?.alcoholByVolume) {
        parts.push(unitText); // show with comma if ABV exists
      } else {
        parts.push(unitText); // single item — no comma needed
      }
    }

    let result = '';

    if (parts.length > 0) {
      const alcoholInfo = parts.join(', ') + '.';
      const styledInfo = `<span style="color: grey; font-style: italic;">${alcoholInfo}</span>`;
      result = `${styledInfo} ${product.description}`;
    } else {
      result = product.description;
    }

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
